import RouterSection from '@/components/layout/RouterSection'

export default {
  path: '/user',
  name: 'user-index',
  component: RouterSection,
  children: [
    {
      path: 'profile',
      name: 'user-profile',
      component: () => import("@/views/user/UserProfile.vue")
    },
    {
      path: 'company/profile',
      name: 'company-profile',
      component: () => import("@/views/user/CompanyProfile.vue")
    },
    {
      path: 'agent/profile',
      name: 'agent-profile',
      component: () => import("@/views/user/AgentProfile.vue")
    },
    {
      path: 'agent/members',
      name: 'agent-members',
      component: () => import("@/views/user/AgentMembers.vue")
    },
    {
      path: 'agent/information',
      name: 'agent-information',
      component: () => import("@/views/user/AgentInformation.vue")
    }
  ]
}
